import React, { useState, useEffect } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../components/common/PageHeader';

export default function TermsOfService({ embedded = false }) {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 640);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{ minHeight: embedded ? 'auto' : '100vh', background: embedded ? 'transparent' : 'linear-gradient(180deg, #eef4f9 0%, #f0faf9 15%, #f8fffe 40%, #ffffff 100%)', paddingBottom: embedded ? 0 : '80px', width: '100%', overflowX: 'clip', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            {/* Header */}
            <div style={{
                display: embedded ? 'none' : 'block',
                background: 'linear-gradient(135deg, #4e8bca 0%, #6a9fd3 60%, #9cc2e6 100%)',
                padding: isMobile ? '28px 20px 32px' : '36px 32px 40px', borderRadius: '0 0 32px 32px',
                position: 'relative', overflow: 'hidden'
            }}>
                <div style={{ position: 'absolute', top: '-30px', right: '-20px', width: '120px', height: '120px', borderRadius: '50%', background: 'rgba(255,255,255,0.08)' }} />
                <div style={{ position: 'absolute', bottom: '-40px', left: '30px', width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,255,255,0.06)' }} />

                <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <BackButton onClick={() => navigate(-1)} label="返回上一頁" />
                    <div>
                        <h1 style={{ fontSize: isMobile ? '1.5rem' : '1.75rem', fontWeight: '800', color: '#ffffff', margin: '0 0 2px 0', letterSpacing: '-0.02em', textShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                            服務條款
                        </h1>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem', margin: 0 }}>
                            了解 JoinU 的服務條款與零容忍政策
                        </p>
                    </div>
                </div>
            </div>

            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: embedded ? 0 : '0 16px' }}>
                <div style={{ maxWidth: embedded ? 'none' : '800px', margin: embedded ? 0 : '24px auto 0' }}>
                    <div style={{ background: 'white', padding: embedded ? '24px' : '32px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                        <h1 style={{ color: '#1f2937', marginBottom: '24px', borderBottom: '2px solid #4e8bca', paddingBottom: '12px' }}>服務條款 (Terms of Service)</h1>

                        <div style={{ background: '#f8fafc', border: '1px solid #dbe4ee', padding: '16px', borderRadius: '12px', marginBottom: '24px', display: 'flex', gap: '12px' }}>
                            <ShieldAlert color="#4e8bca" size={22} strokeWidth={1.9} style={{ flexShrink: 0 }} aria-hidden="true" />
                            <div>
                                <h4 style={{ color: '#1f2937', margin: '0 0 6px 0' }}>零容忍政策 (Zero Tolerance Policy)</h4>
                                <p style={{ margin: 0, color: '#475569', fontSize: '14px', lineHeight: '1.65' }}>
                                    JoinU 針對不當的內容及涉及辱罵、騷擾的使用者行為採取<strong>「絕對零容忍 (Zero tolerance for objectionable content or abusive users)」</strong>政策。違反規定的內容將被立即移除，施暴者帳號將遭永久停權不得有異議。
                                </p>
                            </div>
                        </div>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>1. 條款接受與年齡限制</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            當您下載、註冊或開始使用 JoinU（以下簡稱「本平台」）與其相關服務時，即代表您已閱讀、了解並同意本服務條款及隱私權政策；若您不同意其中任何內容，請勿使用本平台。您聲明並保證您已年滿十八歲，具有簽署、行使與履行本條款之能力與法定權力。若經檢舉並查證您未滿十八歲，您的會員資格將視同無效，本平台得隨時終止您使用本服務。本平台得隨時修改本條款，修改後將透過站內通知或於本頁公告；若您於變更後繼續使用本平台，視為您同意修改後之內容。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>2. 會員互動與線下活動安全</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '8px' }}>
                            JoinU 的核心功能是協助您透過活動（如運動、聚餐、展覽、旅行）認識新朋友。您理解並同意：
                        </p>
                        <ul style={{ lineHeight: '2', color: '#4b5563', fontSize: '15px', marginBottom: '20px', paddingLeft: '20px' }}>
                            <li>本平台僅提供活動媒合之資訊服務，<strong>不會審查會員的身份或背景</strong>，亦不保證會員於個人檔案中所陳述資料之真實性。</li>
                            <li>網路交友具有一定程度之風險，您透過本平台結識之對象有可能使用虛假身份。您應對您與其他會員的互動負一切法律上之責任。</li>
                            <li>參加或發起任何線下活動（包括但不限於運動、聚會、旅行）前，請自行評估活動風險、場地安全與自身身體狀況。<strong>對於會員於線上或線下互動中所生之人身、財產損害或任何糾紛，本平台不負賠償責任</strong>。</li>
                            <li>與其他會員接觸時（不論於本平台、其他通訊軟體或當面），請採取適當措施保護自身安全與隱私。切勿向其他會員透露您的住址、銀行帳號、信用卡號碼或私密照片等敏感資料。</li>
                            <li>初次見面建議選擇公開場所，並告知親友行程。</li>
                        </ul>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>3. 用戶內容與授權 (UGC)</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            當您透過 JoinU 發佈活動、旅伴貼文、個人檔案或留言，您需獨自對您上傳的內容負起全責 (UGC, User Generated Content)。我們禁止色情、仇恨言論、暴力、詐欺及一切違反善良風俗之內容。您同意授權本平台基於服務營運之目的，於服務範圍內使用、重製、公開展示您所上傳之公開內容（如活動資訊、公開個人檔案）；若您無合法權利進行前述授權，請勿上傳該內容，因此侵害第三人權利者，由您自行負責。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>4. 檢舉與封鎖權利</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            為了提供一個安全友善的社群，使用者均同意本應用程式提供「封鎖此對象」與「檢舉違規內容」之功能。本平台營運方會在接到投訴後的24小時內啟動調查，有權不經提前預告直接封停屢遭檢舉之帳戶。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>5. 帳號使用規範</h3>
                        <ul style={{ lineHeight: '2', color: '#4b5563', fontSize: '15px', marginBottom: '20px', paddingLeft: '20px' }}>
                            <li>您必須以本人之真實資訊註冊，每人限持有一個帳號，不得販售、轉讓或與他人共用帳號。</li>
                            <li>您有義務妥善保管帳號之登入方式；經由您帳號所為之行為，除可證明非可歸責於您者外，均由您負責。</li>
                            <li>您不得假冒他人身份、蒐集其他會員個人資料作商業或騷擾用途、發送垃圾訊息或廣告，亦不得以自動化程式抓取本平台之內容與會員資料。</li>
                            <li>您不得從事任何危害本平台安全、干擾服務正常運作或侵害第三方權益之行為。</li>
                        </ul>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>6. 免責聲明</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本平台以現況所具備之條件提供服務。對於因使用或無法使用本平台、系統中斷或故障、資料傳輸錯誤、會員於線上或線下之個人行為、或第三方所提供內容之錯誤所生之直接或間接損害，除法律另有規定外，本平台不負賠償責任。任何第三方透過本平台提供之意見、建議或資訊，均由該第三方自行負責，本平台不為其背書。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>7. 服務變更與帳號終止</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            JoinU 保留隨時修改或暫時、永久停止任何服務或功能的權限。您可隨時於「帳號安全」頁面執行「刪除帳號」以終止會員關係，帳號一經刪除即無法復原。若您違反本條款、遭他人檢舉違規經查證屬實、或本平台有正當理由懷疑您從事違法行為，本平台有權不經預告暫停或永久終止您的帳號，且不負因此所生損失之賠償責任。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>8. 智慧財產權</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本平台之網站架構、介面設計、商標、文字、圖片及其他素材，均受著作權法、商標法與其他法律保護，其所有權屬於本平台或授權方。未經書面許可，您不得對其進行修改、重製、散布、銷售或據以製作衍生著作。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>9. 準據法與管轄法院</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            本條款以中華民國法律為準據法。任何因本條款所生或與本條款有關之爭議，除法律另有規定外，雙方同意以臺灣臺北地方法院為第一審管轄法院。
                        </p>

                        <h3 style={{ color: '#374151', marginTop: '24px', marginBottom: '12px' }}>10. 聯絡我們</h3>
                        <p style={{ lineHeight: '1.8', color: '#4b5563', fontSize: '15px', marginBottom: '20px' }}>
                            如對本服務條款有任何疑問，請透過電子郵件聯繫我們：<strong>service@joinuworld.com</strong>
                        </p>

                        <p style={{ marginTop: '40px', fontSize: '13px', color: '#9ca3af', textAlign: 'center' }}>
                            最後更新日期：2026年7月
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
